import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  path: "",
  url: "",
  params: null as unknown,
};

const pageSlice = createSlice({
  name: "page",
  initialState,
  reducers: {
    // Matches the previous setPage({ path, url, params }) action creator shape.
    setPage: (
      state,
      action: PayloadAction<{ path: any; url: any; params: any }>
    ) => {
      state.path = action.payload.path;
      state.url = action.payload.url;
      state.params = action.payload.params;
    },
  },
});

export const { setPage } = pageSlice.actions;

export default pageSlice.reducer;
